import { pear as pearConstants, questionType } from '@edulastic/constants'

import {
  plusButton,
  minusButton,
  multiplication,
  divide,
  equalSymbol,
  strictLess,
  strictGreater,
  fraction,
  mixedFraction,
  parentheses,
  notEqual,
  angle,
  overline_l_r_arrow,
  overline_r_arrow,
  overline,
  exponentBase,
  distance,
  braces,
  triangle,
  lessEqual,
  greaterEqual,
  piSymbol,
  sqrt,
  mixedSqrt,
  fraction_addtion,
  fraction_subtraction,
  fraction_multiplication,
  numerator_and_denominator_exponent,
  single_quote,
  double_quote,
} from '@edulastic/common/src/components/MathKeyboard/constants/buttons'

const { PA_GRADES_MAP, PA_SUBJECT_VALUES } = pearConstants

export const TEST_SKIN_TYPE_NY_STATE_3_8 = 'ny_3_8_state'

// SKIN TOOLS
export const ZOOM_RESET = 'ZOOM_RESET'
export const ZOOM_OUT = 'ZOOM_OUT'
export const ZOOM_IN = 'ZOOM_IN'
export const CHANGE_COLOR_CONTRAST = 'COLOR_CONTRAST'
export const BOOKMARK = 'BOOKMARK'
export const REFERENCE_MATERIAL = 'REFERENCE_MATERIAL'
export const CHECK_ANSWER = 'CHECK_ANSWER'
export const ANSWER_ELIMINATOR = 'ANSWER_ELIMINATOR'
export const CALCULATOR = 'CALCULATOR'
export const SCRATCHPAD = 'SCRATCHPAD'
export const MAGNIFIER = 'MAGNIFIER'
export const UPLOAD_WORK = 'UPLOAD_WORK'
export const LINE_READER = 'LINE_READER'
export const RULER = 'RULER'
export const PROTRACTOR = 'PROTRACTOR'
export const HIGHLIGHTER = 'HIGHLIGHTER'

export const ny3_8TestSkinGradeSubjectWiseToolsMap = {
  [PA_SUBJECT_VALUES.MATHEMATICS]: {
    grade: {
      [PA_GRADES_MAP.GRADE_3.code]: [ANSWER_ELIMINATOR, RULER, LINE_READER],
      [PA_GRADES_MAP.GRADE_4.code]: [
        REFERENCE_MATERIAL,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
      [PA_GRADES_MAP.GRADE_5.code]: [
        REFERENCE_MATERIAL,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
      [PA_GRADES_MAP.GRADE_6.code]: [
        ANSWER_ELIMINATOR,
        REFERENCE_MATERIAL,
        CALCULATOR,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
      [PA_GRADES_MAP.GRADE_7.code]: [
        ANSWER_ELIMINATOR,
        REFERENCE_MATERIAL,
        CALCULATOR,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
      [PA_GRADES_MAP.GRADE_8.code]: [
        ANSWER_ELIMINATOR,
        REFERENCE_MATERIAL,
        CALCULATOR,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
    },
  },
  [PA_SUBJECT_VALUES.ELA]: {
    grade: {
      allGrades: [ANSWER_ELIMINATOR, LINE_READER],
    },
  },
  [PA_SUBJECT_VALUES.SCIENCE]: {
    grade: {
      [PA_GRADES_MAP.GRADE_5.code]: [
        ANSWER_ELIMINATOR,
        CALCULATOR,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
      [PA_GRADES_MAP.GRADE_6.code]: [
        ANSWER_ELIMINATOR,
        CALCULATOR,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
      [PA_GRADES_MAP.GRADE_7.code]: [
        ANSWER_ELIMINATOR,
        CALCULATOR,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
      [PA_GRADES_MAP.GRADE_8.code]: [
        ANSWER_ELIMINATOR,
        CALCULATOR,
        RULER,
        PROTRACTOR,
        LINE_READER,
      ],
    },
  },
  COMMON_TOOLS: [
    ZOOM_RESET,
    ZOOM_OUT,
    ZOOM_IN,
    CHANGE_COLOR_CONTRAST,
    BOOKMARK,
    SCRATCHPAD,
    UPLOAD_WORK,
    CHECK_ANSWER,
    MAGNIFIER,
    HIGHLIGHTER,
  ],
}

export const ny3_8TestSkinGradeSubjectWiseMathToolsMap = {
  [PA_SUBJECT_VALUES.MATHEMATICS]: {
    grade: {
      [PA_GRADES_MAP.GRADE_2.code]: [
        plusButton,
        minusButton,
        multiplication,
        divide,
        equalSymbol,
        strictLess,
        strictGreater,
        fraction,
        mixedFraction,
      ],
      [PA_GRADES_MAP.GRADE_4.code]: [
        plusButton,
        minusButton,
        multiplication,
        divide,
        equalSymbol,
        strictLess,
        strictGreater,
        fraction_addtion,
        fraction_subtraction,
        fraction_multiplication,
        fraction,
        mixedFraction,
        parentheses,
        notEqual,
        angle,
        overline_l_r_arrow,
        overline_r_arrow,
        overline,
      ],
      [PA_GRADES_MAP.GRADE_6.code]: [
        plusButton,
        minusButton,
        multiplication,
        divide,
        equalSymbol,
        strictLess,
        lessEqual,
        strictGreater,
        greaterEqual,
        fraction_addtion,
        fraction_subtraction,
        fraction_multiplication,
        exponentBase,
        fraction,
        mixedFraction,
        numerator_and_denominator_exponent,
        parentheses,
        distance,
        braces,
        notEqual,
        angle,
        triangle,
        overline_l_r_arrow,
        overline_r_arrow,
        overline,
      ],
      [PA_GRADES_MAP.GRADE_8.code]: [
        plusButton,
        minusButton,
        multiplication,
        divide,
        equalSymbol,
        strictLess,
        lessEqual,
        strictGreater,
        greaterEqual,
        piSymbol,
        single_quote,
        double_quote,
        fraction_addtion,
        fraction_subtraction,
        fraction_multiplication,
        exponentBase,
        fraction,
        mixedFraction,
        numerator_and_denominator_exponent,
        parentheses,
        distance,
        braces,
        sqrt,
        mixedSqrt,
        notEqual,
        angle,
        triangle,
        overline_l_r_arrow,
        overline_r_arrow,
        overline,
      ],
    },
  },
  [PA_SUBJECT_VALUES.SCIENCE]: {
    grade: {
      allGrades: [
        plusButton,
        minusButton,
        multiplication,
        divide,
        equalSymbol,
        strictLess,
        strictGreater,
        fraction,
        mixedFraction,
      ],
    },
  },
}

export const questerDefaultTools = [
  ZOOM_RESET,
  ZOOM_OUT,
  ZOOM_IN,
  BOOKMARK,
  CHECK_ANSWER,
  CHANGE_COLOR_CONTRAST,
  ANSWER_ELIMINATOR,
  CALCULATOR,
  SCRATCHPAD,
  MAGNIFIER,
  UPLOAD_WORK,
  REFERENCE_MATERIAL,
  HIGHLIGHTER,
]

export const highlightToolEnabledQTypes = [
  questionType.ESSAY_PLAIN_TEXT,
  questionType.ESSAY_RICH_TEXT,
  questionType.INLINE_MATH_ESSAY,
  questionType.MULTIPLE_CHOICE,
]
